import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

type UserProfile = {
  phone?: string;
  roles?: string[];
  name?: string;
  profile?: any;
};

type AuthState = {
  token: string | null;
  defaultRole: string | null;
  user: UserProfile | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error?: string | null;
  initialized: boolean;
};

const initialState: AuthState = {
  token: typeof window !== "undefined" ? localStorage.getItem("token") : null,
  defaultRole: typeof window !== "undefined" ? localStorage.getItem("defaultRole") : null,
  user: typeof window !== "undefined" ? JSON.parse(localStorage.getItem("profile") || "null") : null,
  status: "idle",
  error: null,
  initialized: false,
};

export const initializeAuth = createAsyncThunk(
  "auth/initialize",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/auth/get-profile");
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<{ token: string; roles: string[], decoded_token: any } | null>) {
      state.token = action.payload.token;
      state.defaultRole = action.payload?.decoded_token?.defaultRole || "";
      if (action.payload) {
        localStorage.setItem("token", action.payload.token);
        localStorage.setItem("defaultRole", action.payload?.decoded_token?.defaultRole || "");
      }
    },
    switchRole(state, action: PayloadAction<{ default_role: string, token: string }>) {
      console.log("action.payload", action.payload);
      state.token = action.payload.token;
      state.defaultRole = action.payload.default_role;
      localStorage.setItem("defaultRole", action.payload.default_role);
      localStorage.setItem("token", action.payload.token);
      // window.location.reload();
    },
    setUser(state, action: PayloadAction<UserProfile | null>) {
      localStorage.setItem("profile", JSON.stringify(action.payload)); 
      state.user = action.payload;
    },
    logout(state) {
      state.token = null;
      state.user = null;
      state.status = "idle";
      state.error = null;
      state.defaultRole = "";
      state.initialized = true;
      localStorage.removeItem("token");
      localStorage.removeItem("defaultRole");
      localStorage.removeItem("profile");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initializeAuth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(initializeAuth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
        localStorage.setItem("profile", JSON.stringify(action.payload)); 
        state.error = null;
        state.initialized = true;
      })
      .addCase(initializeAuth.rejected, (state, action) => {
        state.status = "failed";
        state.error = (action.payload as any) || "Failed to initialize";
        state.token = null;
        state.user = null;
        localStorage.removeItem("token");
        state.initialized = true;
      });
  },
});

export const { setToken, setUser, logout, switchRole } = authSlice.actions;
export default authSlice.reducer;
